module.exports = __webpack_public_path__ + "img/avatar.3392e399.svg";